const getBrandImage = brand => brand ? `/assets/brands/${brand.replace(new RegExp(/\s/g), '')}@1x.png` : ''

export default getBrandImage
